import { faChevronLeft, faChevronRight, faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useRef, useState } from 'react';
import DeletionModal from '../Modals/Actions/DeletionModal/DeletionModal';
import styles from './Tabs.module.sass';

const Tabs = ({
    data,
    actions,
    active,
    onChange,
    onDelete,
    isDeleting
}: Props) => {
    const [state, setState] = useState({
        isScrolling: false,
        clientX: 0,
        scrollX: 0,
        maxScrollLeft: 7,

        canDelete: false,
        showDeleteConfirmation: false,
        deleteId: ''
    });

    const scroller = useRef<any>();

    const onMouseDown = (e) => {
        setState((state) => ({
            ...state,
            isScrolling: true,
            clientX: e.clientX,
            maxScrollLeft: scroller?.current?.scrollWidth - scroller?.current?.clientWidth
        }));
    };

    const onMouseMove = (e: any) => {
        if (state.isScrolling) {
            let newScrollLeft = state.scrollX + (-1*(e.clientX - state.clientX));
            if (newScrollLeft <= 0) {
                newScrollLeft = 0;
            } else if (newScrollLeft >= state.maxScrollLeft) {
                newScrollLeft = state.maxScrollLeft;
            }
            setState((state) => ({
                ...state,
                scrollX: newScrollLeft,
                clientX: e.clientX
            }));
        }
    }

    const onMouseUp = () => setState((state) => ({
        ...state,
        isScrolling: false
    }));

    const adjust = (space) => setState((state) => ({
        ...state,
        scrollX: state.scrollX + space,
        clientX: state.clientX + space
    }));

    const onRightClick = () => adjust(100);
    const onLeftClick = () => adjust(-100);

    useEffect(() => {
        if (scroller?.current) {
            scroller.current.scrollLeft = state.scrollX;
            setState((state) => ({
                ...state,
                maxScrollLeft: scroller?.current?.scrollWidth - scroller?.current?.clientWidth
            }));
        }
    }, [state.scrollX]);

    const handleDelete = (id: any) => setState((state) => ({
        ...state,
        showDeleteConfirmation: true,
        deleteId: id
    }));

    useEffect(() => {
        if (!isDeleting) {
            setState((state) => ({
                ...state,
                showDeleteConfirmation: false,
                deleteId: ''
            }));
        }
    }, [isDeleting]);

    return <div className={styles['tabs']}>
        { state.showDeleteConfirmation &&
            <DeletionModal
                onClose={() => setState({
                    ...state,
                    showDeleteConfirmation: false
                })}
                onDelete={() => onDelete(state.deleteId)}
                isDeleting={isDeleting}
            >
                Als je { data?.find(i => i.id === state.deleteId)?.title } verwijderd, kan het niet meer worden hersteld.
            </DeletionModal>
        }
        <div className={styles['tabs__content']}>
            {
                state.scrollX >= 8 &&
                <div className={styles['tabs__content-arrow-left']} onClick={onLeftClick}>
                    <FontAwesomeIcon icon={faChevronLeft} />
                </div>
            }

            <div
                ref={scroller}
                className={styles['tabs__content-list']}
                onMouseDown={onMouseDown}
                onMouseMove={onMouseMove}
                onMouseUp={onMouseUp}
                onMouseLeave={onMouseUp}
            >
                {
                    data?.map(i => <div className={`
                        ${styles['tabs__content-item']}
                        ${active === i.id ? styles['tabs__content-item--active'] : ''}
                    `}
                        onClick={() => onChange(i.id)}
                    >
                        { i.title }
                        {
                            onDelete &&
                            <div
                                className={styles['tabs__content-item-delete']}
                                onClick={() => handleDelete(i.id)}
                            >
                                <FontAwesomeIcon icon={faXmark} />
                            </div>
                        }
                    </div>)
                }
            </div>

            {
                state.scrollX <= state.maxScrollLeft - 8 &&
                <div className={styles['tabs__content-arrow-right']} onClick={onRightClick}>
                    <FontAwesomeIcon icon={faChevronRight} />
                </div>
            }
        </div>
        {
            actions &&
            <div className={styles['tabs__actions']}>
                { actions }
            </div>
        }
    </div>;
}

interface Props {
    data: {
        id: string,
        title: string
    }[]
    actions?: any,
    active?: any,
    onChange?: any
    onActionClick?: any
    onDelete?: any
    isDeleting?: any
}

export default Tabs;